const {createPipeline} = require("cleopatra");
const router = require("app/services/router");
const axios = require("axios");
const env = require("app/services/env");
const {createPromiseThrottle} = require("app/util/throttle");
const {reportAndThrow} = require("app/util/errors");

/////////////////////////////////
// Functions
/////////////////////////////////

function addCartIdToRequest(payload) {
	const cartId = env.get("checkout.cart.giftcards.guid");
	payload instanceof FormData ?
		payload.append("cart_id", cartId) :
		(payload.cart_id = cartId);

	return payload;
}

/////////////////////////////////
// Cart change pipeline
/////////////////////////////////

const change = createPipeline().report(reportAndThrow);

change.pipe(payload => {
	if (payload && typeof payload === "object") {
		env.set("checkout.cart.giftcards", payload);
	}

	return payload;
});

/////////////////////////////////
// Add product pipelines
/////////////////////////////////

const throttleAdd = createPromiseThrottle(250);
let add = {};

add.request = createPipeline().report(reportAndThrow);
add.response = createPipeline().report(reportAndThrow);

add.request.pipe(payload => {
	return throttleAdd(payload);
});

add.request.capture(payload => {
	return axios.post(router.route("api.checkout.giftcards.add"), payload).then(response => {
		return add.response.dispatch(response.data);
	});
});

//add.response.capture(change);

add.response.capture(cart => {
	// REDIRECT TO PAYMENT
	if (cart.redirect) {
		window.location = cart.redirect;
	}
});

//add.response.capture(cart => {
//	if (cart.status === "expecting_payment") {
//		window.location = router.route("checkout.payment", {guid: cart.guid});
//		return cart;
//	}
//
//	if (cart.status === "complete") {
//		window.location = router.route("checkout.receipt", {guid: cart.guid});
//		return cart;
//	}
//});

/////////////////////////////////
// Order - this has been moved to add for now
/////////////////////////////////

let order = {};

order.place = createPipeline().report(reportAndThrow);
order.place.pipe(addCartIdToRequest);
order.place.pipe(payload => {
	return axios
		.post(router.route("api.checkout.giftcards.order.place"), payload)
		.then(response => response.data);
});

order.place.capture(cart => {
	if (cart.status === "expecting_payment") {
		window.location = router.route("checkout.payment", {guid: cart.guid});
		return cart;
	}

	if (cart.status === "complete") {
		window.location = router.route("checkout.receipt", {guid: cart.guid});
		return cart;
	}

});

module.exports = {
	add,
	change,
	order
};
